import ResourceService from "./resource.service";

class BrandService extends ResourceService {
  static get resource() {
    return "make";
  }

static create(data) {
    return this.post(data);
  }
}

export default BrandService;